import { cn } from '@newcore/ui/cn';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';
import { LogoVertical } from '@/components/logos';

interface SskSigningScreenProps {
  message: string;
  redirecting: boolean;
}

export function SskSigningScreen({
  message,
  redirecting,
}: SskSigningScreenProps) {
  return (
    <div className='min-h-screen flex items-center justify-center'>
      <div className='flex flex-col items-center gap-6'>
        <LogoVertical />
        <div className='w-[200px] h-[3px] bg-secondary rounded-sm overflow-hidden'>
          <div
            className={cn(
              'h-full bg-[var(--color-text-primary)] rounded-sm',
              redirecting ? 'animate-progress-fill' : 'animate-progress-pulse'
            )}
          />
        </div>
        <Text as='p' size={TextSizes.LG} className='text-secondary'>
          {message}
        </Text>
      </div>
    </div>
  );
}
